import React, { useEffect, useState, useRef, useCallback } from 'react';
import './SplashScreen.css';

export default function SplashScreen({ onComplete }) {
  const [fadeOut, setFadeOut] = useState(false);
  const hasCompleted = useRef(false);

  // Memoize the completion handler to prevent infinite useEffect loops
  const handleComplete = useCallback(() => {
    if (!hasCompleted.current) {
      hasCompleted.current = true;
      setFadeOut(true);
      setTimeout(() => {
        if (onComplete) onComplete();
      }, 600);
    }
  }, [onComplete]);

  useEffect(() => {
    // Minimum display time - use ref-stable handler
    const timer = setTimeout(() => {
      handleComplete();
    }, 1500);

    return () => clearTimeout(timer);
  }, [handleComplete]);

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-background-gradient"></div>
      <div className="splash-glow"></div>
      <div className="splash-content">
        <div className="splash-logo-wrapper">
          <div className="splash-logo-glow"></div>
          <img 
            src="/logo.png" 
            alt="GoPlay Logo" 
            className="splash-logo"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
        <h1 className="splash-title">GoPlay</h1>
        <p className="splash-subtitle">Sports & Activités</p>
        <div className="splash-loader-wrapper">
          <div className="splash-loader">
            <div className="splash-loader-ring"></div>
          </div>
          <div className="splash-loader-glow"></div>
        </div>
      </div>
    </div>
  );
}

